<ng-container [formGroup]="formGroup">
  <div class="gender-box" [class]="validation()">
    <span>{{formatFieldName('Выберите пол')}}</span>
    <div style="display: flex">
      <div class="radio-container" *ngFor="let i of genders">
        <label [for]="i.value">
          <span class="label">{{i.label}}</span>
          <input
            type="radio"
            [id]="'gender-checkbox ' + i.value"
            class="gender-checkbox"
            [ngClass]="[(brand === 'VIVUS' ? 'vivus-style' : '')]"
            formControlName="gender"
            [value]="i.value"
          >
        </label>
      </div>
    </div>
  </div>
  <app-error-message
    [control]="control"
    [field]="fieldName"
    [label]="label"
  ></app-error-message>
</ng-container>
